import { createIcons } from "lucide";
import {
  AirVent,
  ArrowRight,
  ChevronLeft,
  PartyPopper,
  Parasol,
  Bath,
  Baby,
  Bed,
  BrushCleaning,
  Building2,
  CalendarRange,
  Car,
  ChefHat,
  ChevronDown,
  Check,
  CircleHelp,
  ClockArrowDown,
  ClockArrowUp,
  ConciergeBell,
  Coffee,
  Coins,
  EvCharger,
  Eye,
  Flame,
  Goal,
  Heart,
  Heater,
  LandPlot,
  Landmark,
  LampFloor,
  Mail,
  Map,
  MapPin,
  Mountain,
  MessageCircle,
  Pizza,
  Palette,
  PawPrint,
  Ruler,
  Send,
  ShoppingBasket,
  SlidersHorizontal,
  SquareParking,
  Sparkles,
  Sun,
  Tv,
  TreePine,
  Trees,
  Trophy,
  Umbrella,
  UtensilsCrossed,
  Users,
  WashingMachine,
  X,
  Sailboat,
  Waves,
  WavesLadder,
  Wifi,
  Wine,
} from "lucide";

/**
 * Property / booking UI — use in HTML as:
 *   <i data-lucide="map-pin" aria-hidden="true"></i>
 *
 * Semantic map (add new imports + entries here when you use a new icon):
 *   location        → map-pin
 *   landmark / Sehenswürdigkeit → landmark
 *   size / m²       → ruler
 *   kitchen         → chef-hat
 *   breakfast       → coffee
 *   bedroom / Schlafzimmer → bed
 *   Kinderbett      → baby
 *   bathroom / Badezimmer → bath
 *   property type   → building-2
 *   max. guests     → users
 *   Wi‑Fi           → wifi
 *   air conditioning → air-vent
 *   pool            → waves-ladder
 *   sea / coast distance → waves
 *   garden          → trees
 *   Mediterranean garden (optional nuance) → flower-2 / sprout (not in bundle yet; trees is default)
 *   heating & fireplace → heater (flame also reads “fireplace”; use heater to distinguish from grill)
 *   outdoor dining → utensils-crossed
 *   football / sports lawn → goal
 *   plot / estate (Grundstück) → land-plot (pure m² line → ruler)
 *   terrace         → sun
 *   panoramic view / Panoramablick → mountain
 *   view / Ausblick → eye
 *   interior design / Einrichtung → palette
 *   pizza oven / Pizzaofen → pizza (flame = wood-fired fallback)
 *   forest edge / Direkt am Waldrand → tree-pine (trees = garden)
 *   garage parking + wallbox → ev-charger (square-parking / car = parking only)
 *   Smart TV        → tv
 *   BBQ / gas grill → flame
 *   parking / car   → car
 *   private parking → square-parking
 *   washing machine → washing-machine
 *   pets            → paw-print
 *   check-in        → clock-arrow-down
 *   check-out       → clock-arrow-up
 *   SUP-Boards      → sailboat
 *   Outdoor-Hot-Tub → bath
 *   Sauna           → heater
 *   Privater Strand / Sonnenschirm → umbrella (data-lucide="parasol" aliases umbrella; Parasol icon removed in lucide)
 *   aperitivo       → wine
 *   breakfast basket → shopping-basket
 *   massage / spa   → sparkles
 *   housekeeping / cleaning (e.g. Housekeeper) → brush-cleaning
 *   Reinigungsservice inklusive (z.B. 3x pro Woche) → brush-cleaning
 *   concierge / service bell → concierge-bell
 *   floor lamp / lighting → lamp-floor
 *   steps: discover → Map; pick dates → calendar-range; inquiry → send; confirm & pay → badge-PartyPopper
 *   form select     → chevron-down (in .form__select-wrap, see _form.scss)
 *   filter bar (mobile toggle) → sliders-horizontal
 *   contact box       → mail, message-circle (WhatsApp row), Instagram → thin SVG in partial
 */
function initLucideIcons(root = document) {
  createIcons({
    icons: {
      AirVent,
      ArrowRight,
      ChevronLeft,
      PartyPopper,
      Parasol: Umbrella,
      Bath,
      Baby,
      Bed,
      BrushCleaning,
      Building2,
      CalendarRange,
      Car,
      ChefHat,
      ChevronDown,
      Check,
      CircleHelp,
      ClockArrowDown,
      ClockArrowUp,
      ConciergeBell,
      Coffee,
      Coins,
      EvCharger,
      Eye,
      Flame,
      Goal,
      Heart,
      Heater,
      LandPlot,
      Landmark,
      LampFloor,
      Mail,
      Map,
      MapPin,
      Mountain,
      MessageCircle,
      Pizza,
      Palette,
      PawPrint,
      Ruler,
      Send,
      ShoppingBasket,
      SlidersHorizontal,
      SquareParking,
      Sparkles,
      Sun,
      Tv,
      TreePine,
      Trees,
      Trophy,
      Umbrella,
      UtensilsCrossed,
      Users,
      WashingMachine,
      X,
      Sailboat,
      Waves,
      WavesLadder,
      Wifi,
      Wine,
    },
    attrs: {
      width: 20,
      height: 20,
      "stroke-width": 1.25,
    },
    root,
  });
}

export { initLucideIcons };

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLucideIcons);
} else {
  initLucideIcons();
}
